import { type Prices, Product } from "@b2bportal/purchase-api";
import {
  type CartUpdateError,
  CartUpdateState,
  ParentState,
} from "@checkout/types";
import type { State } from "xstate";
import { getChildState } from "../../../helpers";
import {
  HtsLodgingCfarSelectors,
  LodgingCfarSelectorsV1,
} from "../../Products";
import type { CartContext } from "../context";

type CartUpdateStateType = State<CartContext>;
type CartUpdateStateWithoutValue = Pick<CartUpdateStateType, "context">;

export const getCartUpdateParams = ({
  context,
}: CartUpdateStateWithoutValue) => ({
  addPayments: context[ParentState.cartUpdate].addPayments,
  addProducts: context[ParentState.cartUpdate].addProducts,
  removeProducts: context[ParentState.cartUpdate].removeProducts,
  removePayments: context[ParentState.cartUpdate].removePayments,
});

export const getCartUpdateCallState = (state: CartUpdateStateType) =>
  state.context[ParentState.cartUpdate].callState;

export const getCartUpdateError = (
  state: CartUpdateStateType
): CartUpdateError | undefined => state.context[ParentState.cartUpdate].error;

export const getOpenCartUpdateModal = (state: CartUpdateStateType) =>
  [CartUpdateState.update, CartUpdateState.getBreakdown].includes(
    getChildState(state.value) as CartUpdateState
  ) && Object.keys(state.value).includes(ParentState.cartUpdate);

export type CartQuoteBreakdownProducts = {
  [Product.LodgingCfar]?: {
    totalPremiumAmount: Prices;
  };
  [Product.HtsLodgingCfar]?: {
    totalPremiumAmount: Prices;
  };
};

type CfarUpdateState = LodgingCfarSelectorsV1.CfarUpdateStateWithoutValue &
  HtsLodgingCfarSelectors.CfarUpdateStateWithoutValue;

export const getCartSelectedProducts = (
  state: CfarUpdateState
): CartQuoteBreakdownProducts => {
  const selectedCfarOffer =
    LodgingCfarSelectorsV1.getSelectedCfarOffer(state)?.offer;

  const selectedHtsCfarOffer =
    HtsLodgingCfarSelectors.getSelectedCfarOffer(state)?.offer;

  return {
    [Product.LodgingCfar]: selectedCfarOffer
      ? {
          totalPremiumAmount: selectedCfarOffer.premiumAmount,
        }
      : undefined,
    [Product.HtsLodgingCfar]: selectedHtsCfarOffer
      ? {
          totalPremiumAmount: selectedHtsCfarOffer.premiumAmount,
        }
      : undefined,
  };
};
